import { render } from "./LocationTreePanel.vue?vue&type=template&id=20686a1a&scoped=true"
import script from "./LocationTreePanel.vue?vue&type=script&lang=js"
export * from "./LocationTreePanel.vue?vue&type=script&lang=js"

import "./LocationTreePanel.vue?vue&type=style&index=0&id=20686a1a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20686a1a"]])

export default __exports__